// Joya Headquarter — ordering pages (Hebrew). Same keys as orders.en.js.
export default {
  'joya.orders.title': 'הזמנות והשלמת מלאי',
  'joya.orders.subAll': 'כל הסניפים',
  'joya.orders.generate': 'הפקת המלצה',
  'joya.orders.generateGo': 'הפקה',
  'joya.orders.generateAgain': 'הפקת המלצה חדשה בכל זאת',
  'joya.orders.generateFor': 'המלצה לסניף: {name}',
  'joya.orders.openExisting': 'פתיחת הטיוטה הקיימת',
  'joya.orders.existingDraft': 'כבר יש טיוטה לסניף הזה בתאריך הזה. אפשר לפתוח אותה או להפיק המלצה חדשה.',
  'joya.orders.manual': 'רשימה ריקה',
  'joya.orders.newGoesTo': 'רשימה חדשה תיפתח לסניף {name}. כדי לבחור סניף אחר, בחרו אותו בראש העמוד.',
  'joya.orders.listDate': 'תאריך הרשימה',
  'joya.orders.none': 'אין רשימות להצגה.',
  'joya.orders.filter.open': 'פתוחות',
  'joya.orders.filter.DRAFT': 'טיוטות',
  'joya.orders.filter.APPROVED': 'מאושרות',
  'joya.orders.filter.ORDERED': 'הוזמנו',
  'joya.orders.filter.REJECTED': 'נדחו',
  'joya.orders.filter.all': 'הכול',
  'joya.orders.origin': 'מקור',
  'joya.orders.origin.RECOMMENDATION': 'המלצת המערכת',
  'joya.orders.origin.MANUAL': 'רשימה ידנית',
  'joya.orders.origin.HISTORICAL_IMPORT': 'הזמנה היסטורית (ייבוא)',
  'joya.orders.lines': 'פריטים',
  'joya.orders.createdBy': 'נוצרה',
  'joya.orders.approvedBy': 'אושרה',
  'joya.orders.orderedBy': 'הוזמנה בפועל',
  'joya.orders.rejectedBy': 'נדחתה',
  'joya.orders.noStockNote': 'המערכת לא יודעת כמה מלאי יש לכם עכשיו. הכמויות הן הצעה, לפי רשימות סופיות קודמות ולפי המכירות.',

  'joya.orders.listTitle': 'רשימת הזמנה',
  'joya.orders.workingLines': 'הרשימה',
  'joya.orders.emptyList': 'הרשימה ריקה. הוסיפו פריטים.',
  'joya.orders.lineOrigin.RECOMMENDED': 'הומלץ',
  'joya.orders.lineOrigin.ADDED': 'נוסף ידנית',
  'joya.orders.freeText': 'טקסט חופשי',
  'joya.orders.qty': 'כמות',
  'joya.orders.qtyPh': 'כמות',
  'joya.orders.unit': 'יחידה',
  'joya.orders.recommended': 'הומלץ:',
  'joya.orders.setQtyOrRemove': 'אין כמות — הזינו כמות או הסירו את הפריט לפני האישור.',
  'joya.orders.why': 'למה?',
  'joya.orders.remove': 'הסרה',
  'joya.orders.restore': 'החזרה לרשימה',
  'joya.orders.notSaved': 'עוד לא נשמר',
  'joya.orders.unsaved': 'יש שינויים שלא נשמרו',
  'joya.orders.qtyPositive': 'כמות צריכה להיות גדולה מ-0 (או הסירו את הפריט)',
  'joya.orders.undoAll': 'ביטול כל השינויים',
  'joya.orders.saveFirst': 'קודם שמרו את השינויים',
  'joya.orders.approveList': 'אישור הרשימה',
  'joya.orders.addItem': 'הוספת פריט',
  'joya.orders.markOrdered': 'סימון שהוזמן בפועל',
  'joya.orders.reopen': 'פתיחה מחדש לעריכה',
  'joya.orders.copyText': 'העתקת הרשימה כטקסט',
  'joya.orders.copied': 'הועתק ✓',
  'joya.orders.removedLines_one': 'פריט אחד הוסר',
  'joya.orders.removedLines_other': '{count} פריטים הוסרו',
  'joya.orders.notDue_one': 'עוד לא הגיע הזמן — פריט אחד',
  'joya.orders.notDue_other': 'עוד לא הגיע הזמן — {count} פריטים',
  'joya.orders.notDueHelp': 'פריטים שאתם מזמינים בדרך כלל, אבל לפי הקצב הרגיל שלכם עוד לא הגיע הזמן להזמין אותם. אפשר להוסיף.',
  'joya.orders.addToList': 'הוספה לרשימה',
  'joya.orders.itemSearch': 'פריט',
  'joya.orders.itemSearchHint': 'חפשו בקטלוג, או כתבו שם חופשי.',
  'joya.orders.freeTextHint': 'לא נבחר פריט מהקטלוג — הפריט יישמר כטקסט חופשי.',
  'joya.orders.qtyOptional': 'אפשר להשאיר ריק עכשיו, אבל לפני האישור צריך כמות.',
  'joya.orders.ex1': 'תוסיף 2 ארגזים של לימונים',
  'joya.orders.ex2': 'למה כל כך הרבה עגבניות?',
  'joya.orders.ex3': 'תוריד את המפיות',

  'joya.orders.why.manual': 'הפריט נוסף ידנית — אין לו המלצה.',
  'joya.orders.why.method': 'איך חושבה הכמות',
  'joya.orders.why.weight': 'משקל',
  'joya.orders.why.examples_one': 'רשימה סופית אחת שהמערכת למדה ממנה',
  'joya.orders.why.examples_other': '{count} רשימות סופיות שהמערכת למדה מהן',
  'joya.orders.why.ratios_one': 'יחס אחד: כמות שהוזמנה ÷ מנות שנמכרו',
  'joya.orders.why.ratios_other': '{count} יחסים: כמות שהוזמנה ÷ מנות שנמכרו',
  'joya.orders.method.SALES_RATIO': 'לפי המכירות (יחס הזמנה למנות שנמכרו)',
  'joya.orders.method.HISTORY_MEDIAN': 'לפי הכמויות שהזמנתם בעבר',
  'joya.orders.method.RECIPE_ESTIMATE': 'הערכה לפי מתכונים — לא ספירת מלאי',
  'joya.orders.method.NONE': 'אין בסיס לכמות — השלימו בעצמכם',
  'joya.orders.exStatus.ORDERED': 'הוזמן',
  'joya.orders.exStatus.APPROVED': 'אושר בלבד (משקל נמוך יותר)',
  'joya.orders.exStatus.HISTORICAL': 'היסטורי',
  'joya.orders.reason.SHORTAGE': 'דווח חוסר: {dates}',
  'joya.orders.reason.DUE_BY_INTERVAL': 'הגיע הזמן: עברו {daysSince} ימים מההזמנה האחרונה, ובדרך כלל מזמינים כל {medianInterval} ימים (סף: {threshold}).',
  'joya.orders.reason.NOT_DUE_BY_INTERVAL': 'עוד לא הגיע הזמן: עברו {daysSince} ימים, ובדרך כלל מזמינים כל {medianInterval} ימים.',
  'joya.orders.reason.ORDERED_ONCE': 'הוזמן רק פעם אחת ({date}, כמות {qty}) — אין מספיק היסטוריה לכמות.',
  'joya.orders.reason.NO_HISTORY': 'אין היסטוריית הזמנות לפריט הזה בסניף.',
  'joya.orders.reason.LINKED_SALES': 'נמכרו {units} מנות מ-{dishes} מנות שמשתמשות בפריט ({from} – {to}).',
  'joya.orders.reason.daysMissing': 'חסרים נתוני מכירות ל-{n} ימים.',
  'joya.orders.notes.SALES_WINDOW_INCOMPLETE': 'חסרים נתוני מכירות ל-{daysMissing} ימים מאז ההזמנה האחרונה, לכן לא חושב לפי המכירות.',
  'joya.orders.notes.NO_RECIPE_ESTIMATE': 'אין הערכה לפי מתכונים: {reason}',
  'joya.orders.notes.OFTEN_REMOVED': 'הסרתם את הפריט {removed} מתוך {suggested} פעמים שהוצע — לכן הוא רק לבדיקה.',
  'joya.orders.notes.NO_LINKED_DISHES': 'הפריט לא מקושר לאף מנה בתפריט, לכן אין חישוב לפי מכירות.',

  'joya.orders.original': 'ההמלצה המקורית של המערכת',
  'joya.orders.originalHelp': 'כך המערכת המליצה, לפני שינויים. היא לא משתנה.',
  'joya.orders.section.SUGGESTED': 'מומלץ להזמין',
  'joya.orders.section.CHECK': 'לבדיקה (כמות להשלמה)',
  'joya.orders.section.NOT_DUE': 'עוד לא הגיע הזמן',
  'joya.orders.editLog': 'יומן שינויים',
  'joya.orders.act.ADD': 'הוספה',
  'joya.orders.act.REMOVE': 'הסרה',
  'joya.orders.act.RESTORE': 'החזרה',
  'joya.orders.act.SET_QTY': 'שינוי כמות',
  'joya.orders.act.NOTE': 'הערה',
  'joya.orders.act.APPROVE': 'אישור הרשימה',
  'joya.orders.act.MARK_ORDERED': 'סומן שהוזמן',
  'joya.orders.act.REJECT': 'דחייה',
  'joya.orders.act.REOPEN': 'פתיחה מחדש',
  'joya.orders.via.UI': 'במסך',
  'joya.orders.via.CHAT': 'בשיחה',

  'joya.orders.confirm.approve': 'אישור הרשימה',
  'joya.orders.confirm.ordered': 'סימון שההזמנה בוצעה',
  'joya.orders.confirm.reject': 'דחיית הרשימה',
  'joya.orders.confirm.reopen': 'פתיחה מחדש',
  'joya.orders.confirmBtn.approve': 'אישור',
  'joya.orders.confirmBtn.ordered': 'כן, הזמנתי',
  'joya.orders.confirmBtn.reject': 'דחייה',
  'joya.orders.confirmBtn.reopen': 'פתיחה מחדש',
  'joya.orders.confirmText.approve': 'אחרי האישור הרשימה נשמרת כרשימה הסופית ואי אפשר לערוך אותה (אפשר לפתוח מחדש). ההזמנה עצמה לא נשלחת לספק.',
  'joya.orders.confirmText.ordered': 'סמנו רק אם ביצעתם את ההזמנה בפועל מול הספק. הרשימה תשמש את המערכת כדוגמה ללמידה.',
  'joya.orders.confirmText.reject': 'הרשימה לא תשמש להזמנה ולא ללמידה.',
  'joya.orders.confirmText.reopen': 'הרשימה תחזור לטיוטה ותוכלו לערוך אותה שוב.',

  'joya.short.title': 'דיווח חוסרים',
  'joya.short.report': 'דיווח על חוסר',
  'joya.short.item': 'מה חסר?',
  'joya.short.itemHint': 'חפשו בקטלוג, או כתבו שם חופשי.',
  'joya.short.date': 'תאריך',
  'joya.short.submit': 'שליחת דיווח',
  'joya.short.saved': 'הדיווח נשמר ✓',
  'joya.short.savedFreeText': 'הדיווח נשמר כטקסט חופשי — הוא לא מקושר לפריט בקטלוג, ולכן לא ישפיע על ההמלצות.',
  'joya.short.noReportNote': 'אם לא דווח חוסר, זה לא אומר שההזמנה הייתה נכונה — דווחו על כל חוסר שאתם רואים.',
  'joya.short.recent': 'דיווחים מ-30 הימים האחרונים',
  'joya.short.none': 'אין דיווחים.',
  'joya.short.freeText': 'טקסט חופשי',

  'joya.learned.title': 'מה המערכת למדה',
  'joya.learned.showingFirst': 'מוצג הסניף {name}. כדי לראות סניף אחר, בחרו אותו בראש העמוד.',
  'joya.learned.howTitle': 'איך המערכת לומדת',
  'joya.learned.how1': 'כל רשימה סופית (שאושרה או שהוזמנה) היא דוגמה ללמידה. רשימה שהוזמנה בפועל שווה יותר מרשימה שרק אושרה.',
  'joya.learned.how2': 'רשימות חדשות שוות יותר מרשימות ישנות.',
  'joya.learned.how3': 'הכמות לפי המכירות מחושבת רק כשיש נתוני מכירות לכל הימים מאז ההזמנה הקודמת.',
  'joya.learned.how4': 'כשאין בסיס מספיק, המערכת לא ממציאה כמות — היא משאירה את הפריט לבדיקה שלכם.',
  'joya.learned.how5': 'כל סניף נלמד בנפרד.',
  'joya.learned.how6': 'רשימה סופית היא דוגמה לאופן ההזמנה, לא מדידה של צריכה בפועל.',
  'joya.learned.none': 'עוד אין מה להראות. אחרי שתאשרו רשימות (או תייבאו הזמנות קודמות), המערכת תתחיל ללמוד.',
  'joya.learned.examples_one': 'דוגמה אחת',
  'joya.learned.examples_other': '{count} דוגמאות',
  'joya.learned.lastOrdered': 'הוזמן לאחרונה',
  'joya.learned.interval': 'ימים בין הזמנות (חציון)',
  'joya.learned.days': 'ימים',
  'joya.learned.typicalQty': 'כמות רגילה (חציון משוקלל)',
  'joya.learned.ratio': 'כמות לכל מנה שנמכרה',
  'joya.learned.ratioN_one': 'מחושב מהזמנה אחת',
  'joya.learned.ratioN_other': 'מחושב מ-{count} הזמנות',
  'joya.learned.noRatio': 'אין מספיק נתוני מכירות מלאים לחישוב',
  'joya.learned.removed': 'הוסר על ידכם / הוצע',
};
